<div class="modal-body text-center py-5 px-4">
  <i class="bi bi-clock-history fs-1 text-warning mb-3 d-block"></i>
  <h4 class="fw-bold mb-2">Session Expiring Soon</h4>
  <p class="text-gray-600 mb-4">
    You've been inactive. You will be automatically logged out in
    <span class="fw-bold text-danger">{{ countdown }}</span>
    second{{ countdown !== 1 ? 's' : '' }}.
  </p>
  <button class="btn btn-primary px-5" (click)="stay()">Stay Logged In</button>
</div>
